// extracted by mini-css-extract-plugin
export var bioButton = "TeamMemberCard-module--bioButton--LyWz9";
export var bioLine = "TeamMemberCard-module--bioLine--RWWUs";
export var bioText = "TeamMemberCard-module--bioText--u8Uyf";
export var cardContent = "TeamMemberCard-module--cardContent--ZZcqF";
export var imageWrapper = "TeamMemberCard-module--imageWrapper--FXuAE";
export var infoSection = "TeamMemberCard-module--infoSection--+6kUv";
export var memberCompany = "TeamMemberCard-module--memberCompany--TTyWA";
export var memberDesignation = "TeamMemberCard-module--memberDesignation--xvo3q";
export var memberName = "TeamMemberCard-module--memberName--iwRhC";
export var profileImage = "TeamMemberCard-module--profileImage--O6uMG";
export var teamCard = "TeamMemberCard-module--teamCard--u2Uf9";